import React from "react";
import './Table.css'

const TableTwo = ({
    pTableTwoTitle,
    pTableTwoN1, 
    pTableTwoV1,
    pTableTwoN2,
    pTableTwoV2,
    pTableTwoN3,
    pTableTwoV3,
    pTableTwoN4,
    pTableTwoV4
}) =>{
    return(
        <div id="tablebox-2"> <b className="heading">{pTableTwoTitle}</b>
            <table class="table2">
                <tbody>
                    <tr>
                        <td class="td2"  width="100">{pTableTwoN1}</td>
                        <td class="td2">{pTableTwoV1}</td>
                    </tr>
                    <tr>
                        <td class="td2"  width="100">{pTableTwoN2}</td>
                        <td class="td2">{pTableTwoV2}</td>
                    </tr>
                    <tr>
                        <td class="td2"  width="100">{pTableTwoN3}</td>
                        <td class="td2">{pTableTwoV3}</td>
                    </tr>
                    <tr>
                        <td class="td2"  width="100">{pTableTwoN4}</td>
                        <td class="td2">{pTableTwoV4}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default TableTwo